import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import pending from "../../images/activity.png";

export default function PendingReports({ report }) {
  return <ReportCard title="Pending Reports" text={report} src={pending} />;
}
